export default __webpack_public_path__ + "static/media/characters.6233cf55.svg";